import { CALL_API } from '../middleware/ApiMiddleware';

export const NOTICE_FORM_SECTION_LIST_FETCH_REQUEST = 'NOTICE_FORM_SECTION_LIST_FETCH_REQUEST';
export const NOTICE_FORM_SECTION_LIST_FETCH_SUCCESS = 'NOTICE_FORM_SECTION_LIST_FETCH_SUCCESS';
export const NOTICE_FORM_SECTION_LIST_FETCH_FAILURE = 'NOTICE_FORM_SECTION_LIST_FETCH_FAILURE';

export const NOTICE_FORM_SECTION_FETCH_REQUEST = 'NOTICE_FORM_SECTION_FETCH_REQUEST';
export const NOTICE_FORM_SECTION_FETCH_SUCCESS = 'NOTICE_FORM_SECTION_FETCH_SUCCESS';
export const NOTICE_FORM_SECTION_FETCH_FAILURE = 'NOTICE_FORM_SECTION_FETCH_FAILURE';

export const NOTICE_FORM_SECTION_EDIT_REQUEST = 'NOTICE_FORM_SECTION_EDIT_REQUEST';
export const NOTICE_FORM_SECTION_EDIT_SUCCESS = 'NOTICE_FORM_SECTION_EDIT_SUCCESS';
export const NOTICE_FORM_SECTION_EDIT_FAILURE = 'NOTICE_FORM_SECTION_EDIT_FAILURE';

export const NOTICE_FORM_SECTION_CREATE_REQUEST = 'NOTICE_FORM_SECTION_CREATE_REQUEST';
export const NOTICE_FORM_SECTION_CREATE_SUCCESS = 'NOTICE_FORM_SECTION_CREATE_SUCCESS';
export const NOTICE_FORM_SECTION_CREATE_FAILURE = 'NOTICE_FORM_SECTION_CREATE_FAILURE';

const noticeFormSectionURL = 'xerce/config/notice-form-sections';

export const fetchNoticeFormSections = () => ({
  [CALL_API]: {
    endpoint: noticeFormSectionURL,
    method: 'get',
    authenticated: true,
    types: [
      NOTICE_FORM_SECTION_LIST_FETCH_REQUEST,
      NOTICE_FORM_SECTION_LIST_FETCH_SUCCESS,
      NOTICE_FORM_SECTION_LIST_FETCH_FAILURE,
    ],
  },
});

export const fetchNoticeFormSection = (noticeFormSectionId: number) => ({
  [CALL_API]: {
    endpoint: `${noticeFormSectionURL}/${noticeFormSectionId}`,
    method: 'get',
    authenticated: true,
    types: [NOTICE_FORM_SECTION_FETCH_REQUEST, NOTICE_FORM_SECTION_FETCH_SUCCESS, NOTICE_FORM_SECTION_FETCH_FAILURE],
  },
});

export const editNoticeFormSection = (
  noticeFormSectionId: number,
  noticeFormSectionEditRequest: IConfigNoticeFormSectionEditRequest
) => ({
  [CALL_API]: {
    endpoint: `${noticeFormSectionURL}/${noticeFormSectionId}`,
    method: 'put',
    body: noticeFormSectionEditRequest,
    authenticated: true,
    types: [NOTICE_FORM_SECTION_EDIT_REQUEST, NOTICE_FORM_SECTION_EDIT_SUCCESS, NOTICE_FORM_SECTION_EDIT_FAILURE],
  },
});

export const createNoticeFormSection = (noticeFormSectionRequest: IConfigNoticeFormSectionRequest) => ({
  [CALL_API]: {
    endpoint: noticeFormSectionURL,
    method: 'post',
    body: noticeFormSectionRequest,
    authenticated: true,
    types: [NOTICE_FORM_SECTION_CREATE_REQUEST, NOTICE_FORM_SECTION_CREATE_SUCCESS, NOTICE_FORM_SECTION_CREATE_FAILURE],
  },
});
